import React from "react";
import { connect } from "react-redux";
import { Route, Navigate } from "react-router-dom";

import Header from "../components/Header";

const PublicRoute = ({ component: Component, isAuthenticated, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? (
        <Navigate to="/" />
      ) : (
        <div>
          <Header />
          <br />
          <Component {...props} />
        </div>
      )
    }
  />
);

const mapStateToProps = state => ({
  isAuthenticated: !!state.auth.id
});

export default connect(mapStateToProps)(PublicRoute);
